import { lang } from 'botpress/shared'
import React, { FC, useState } from 'react'
import { RouteComponentProps } from 'react-router'
import { Redirect } from 'react-router-dom'

import BasicAuthentication from '~/auth/basicAuth'
import bgImage from '../assets/images/bg.png'
import logo from '../assets/images/xmati.png'
import { ChangePasswordForm } from './ChangePasswordForm'
import LoginContainer from './LoginContainer'
import '../app/Wizard/style.css'

type RouterProps = RouteComponentProps<undefined, {}, { email: string; password: string; loginUrl: string }>
type Props = { auth: BasicAuthentication } & RouterProps

export const ChangePassword: React.FC = () => {
  const [error, setError] = useState<string>()
  //const { email, password, loginUrl } = props.location.state

  // const updatePassword = async (newPassword: string, confirmPassword: string) => {
  //   if (newPassword !== confirmPassword) {
  //     return setError(lang.tr('admin.passwordsDontMatch'))
  //   }
  // }

  return (
    <div className='parent-wizard-container' style={{
      backgroundImage: `url(${bgImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      width: '100%',
      height: '100vh',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Robot Banner Overlay */}
      <div style={{
        position: 'absolute',
        top: '65%',
        left: '65%',
        transform: 'translateY(-50%)',
        width: 'auto',
        height: 'auto',
        maxWidth: '600px',
        maxHeight: '600px',
        pointerEvents: 'none',
        zIndex: 0,
      }}>
        <img
          src={`${process.env.PUBLIC_URL || ''}/banner-robot.png`}
          alt="Robot Banner"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            opacity: 0.7,
          }}
        />
      </div>
      <div style={{ position: 'relative', zIndex: 1, width: '100%', height: '100vh', overflow: 'hidden' }}>
        <div className='wizard-header-container' style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '10px 20px',
          whiteSpace: 'nowrap'
        }}>
          <img src={logo} alt='logo' className='wizard-header-logo' />
          <h3 style={{
            flex: 1,
            textAlign: 'center',
            color: 'white',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>
            Reset Password
          </h3>
          <div style={{ width: '45px' }}></div>
        </div>
        <div className='auth-wizard-container' style={{ width: '50%', maxWidth: '500px', minWidth: '400px', minHeight: 'auto', margin: '100px auto 20px auto' }}>
          <div className='auth-wizard-body' style={{ minHeight: 'auto' }}>
            <div className='auth-step' style={{ padding: '20px 15px', minHeight: 'auto', gap: '10px' }}>
              <div style={{
                textAlign: 'center',
                fontSize: '24px',
                fontWeight: 'bold',
                marginBottom: '5px',
                fontFamily: 'Lato, sans-serif',
                color: '#333'
              }}>
                Reset Your Password
              </div>
              <div className='stepSubtitle' style={{ textAlign: 'center', marginBottom: '15px', width: '90%', fontSize: '13px' }}>Please follow the steps to reset your password</div>
              {error && (
                <div className='error' style={{ marginBottom: '15px', textAlign: 'center' }}>
                  {error}
                </div>
              )}
              <ChangePasswordForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChangePassword
